import React from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import AiResponse from './response/AiResponse';

import SeoMeta from './SeoMeta';
const ResultsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const prompt = searchParams.get('prompt');

  if (!prompt) {
    navigate('/ask');
    return null;
  }

  return (
    <div className="min-h-screen bg-white">
      <SeoMeta title="AI Research Results | IndianStockMarketGPT" description="AI-generated educational research summary." robots="noindex, follow" />
      {/* Top bar */}
      <div className="border-b border-slate-100 sticky top-16 z-20 bg-white/90 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
          <button
            onClick={() => navigate('/ask')}
            className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back
          </button>

          {/* Mini prompt hint */}
          <div
            className="flex-1 max-w-xl hidden sm:flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 cursor-pointer hover:border-navy-300 transition-colors"
            onClick={() => navigate('/ask')}
          >
            <Sparkles className="h-3.5 w-3.5 text-navy-500 shrink-0" />
            <span className="text-sm text-slate-500 truncate">{prompt}</span>
          </div>

          <Link
            to="/ask"
            className="text-[11px] px-3 py-1.5 rounded-lg bg-navy-500 hover:bg-navy-600 text-white font-semibold transition-all"
          >
            New query
          </Link>
        </div>
      </div>

      <AiResponse prompt={prompt} />
    </div>
  );
};

export default ResultsPage;
